import {GET_MAP_PSP_OSP_ACCOUNTS} from '../../actions/actiontypes';
import {normalize} from '../../util/utils';

const initialState = {
	allIds: [],
	byId: {}
};

/**
 * Reducer for Body 354 accounts (Map PSP/OSP to Risk by Account).
 * Separate from the shared accounts reducer to avoid collisions when
 * both body types exist in the same section.
 */
export default function mapPSPOSPAccountsReducer(state = initialState, action) {
	switch (action.type) {
		case GET_MAP_PSP_OSP_ACCOUNTS: {
			if (action.response && action.response.data) {
				return normalize(action.response.data, undefined, undefined, undefined, true);
			}
			return state;
		}
		default:
			return state;
	}
}
